<!--Footer Starts-->
<footer>
    <div class="container-fluid">
        <!-- <p class="copyright text-center">
                Copyright  &copy;  {{currentDate | date: 'yyyy'}} <a id="pixinventLink" href="https://dataline-qa.com">DataLine</a>, All rights reserved.          
        </p> -->
        
    </div>
</footer>
<!--Footer Ends-->